import React from 'react'
import { DcInput, PixelCheckboxGroup } from 'pixel-base'
import styled from 'styled-components'

import { ComplaintProduct, ComplaintRequest } from '../../../../../../../decl'

interface IProps {
  item: ComplaintProduct
  setData: (data: ComplaintRequest) => void
  data: ComplaintRequest
  setExchangeAble: (exchangeAble: boolean) => void
}
const ComplaintProductLineEdit = (props: IProps) => {
  const { item, setData, data, setExchangeAble } = props
  return (
    <>
      <Form>
        <FormGroup direction>
          <PixelCheckboxGroup
            options={[
              {
                label: 'refund',
                value: 'refund',
                type: 'radio',
                checked: item.resolution_type === 'refund',
              },
              {
                label: 'exchange',
                value: 'exchange',
                type: 'radio',
                checked: item.resolution_type === 'exchange',
              },
            ]}
            onChange={(e) => {
              setData({
                ...data,
                resolution_type: e.target.value,
                products: data.products.map((product) => {
                  if (product.sku === item.sku) {
                    return {
                      ...product,
                      resolution_type: e.target.value,
                    }
                  }
                  return product
                }),
              })
              if (e.target.value === 'exchange') {
                setExchangeAble(true)
              } else {
                setExchangeAble(false)
              }
            }}
          />
          <DcInput
            isShowError={
              data.resolution_type === 'refund'
                ? data.refund_amount <= 0
                : false
            }
            errorMessage={'Refund amount must be greater than 0'}
            required
            type={'number'}
            name={'amount'}
            placeholder={'Enter Refund amount'}
            value={
              data.resolution_type === 'refund' || data.refund_amount !== 0
                ? data.refund_amount
                : ''
            }
            onChange={(e) =>
              setData({
                ...data,
                refund_amount: e.target.value,
              })
            }
          />
        </FormGroup>
      </Form>
    </>
  )
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean; direction?: boolean }>`
  display: inline-flex;
  flex-direction: ${(props) => (props.direction ? 'column' : 'row')};
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'space-between')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`

export default ComplaintProductLineEdit
